var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationChatBubbles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M72 53h-2.414l-12-12H53v-2h5.414L70 50.586V13H27v12h-2V11h47v42",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M35 35h2v-2h-2zM39 35h2v-2h-2zM43 35h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M31 19h2v-2h-2zM35 19h2v-2h-2zM39 19h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M14 35h17v-2H14zM14 39h31v-2H14z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M53 29h13v-2H53zM53 33h13v-2H53z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 29v37.586L21.586 55H49V29H10zm.414 40H8V27h43v30H22.414l-12 12z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M31 23h35v-2H31zM45 19h21v-2H45z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M14 49h21v-2H14zM14 45h31v-2H14z",
    className: "fi-icon-illustrative-highlight-fill"
  }))));
}

export default SvgIconIllustrationChatBubbles;